// extracted by mini-css-extract-plugin
export var createdDate = "_m6-1";
export var divider = "_m6-2";
export var headerDivider = "_m6-3";
export var messagesCard = "_m6-0";
export var messagesContainer = "_m6-7";
export var messagesContainerWrapper = "_m6-4";
export var pointerCapturingButtonBoxes = "_m6-a";
export var showLeftPanelButton = "_m6-9";
export var showMoreButton = "_m6-c";
export var showMoreButtonContainer = "_m6-b";
export var summaryTitle = "_m6-6";
export var systemMessageCardWrapper = "_m6-d";
export var topButtons = "_m6-8";
export var withPadding = "_m6-5";